import { logger } from '@modules/logger';
import { createContext } from 'react';

const initialEditedCardFieldsContext = {
  editedAttributes: [],
  onEditAttribute: () => logger.warn('onEditAttribute has not been implemented for editedCardFieldsContext'),
};

interface editedCardFieldsContextValues {
  editedAttributes: string[];
  onEditAttribute: (id: string) => void;
}

const editedCardFieldsContext = createContext<editedCardFieldsContextValues>(initialEditedCardFieldsContext);

export { editedCardFieldsContext };
